import ApiHandler from "./ApiHandler";

const Olympiad = {
  deleteOne: async (olympiadId) => await ApiHandler.i.auth().delete(`/olympiad/${olympiadId}`),
  findAll: async (query) => await ApiHandler.i.auth().get(`/olympiad/find-all?${query.toString()}`),
  findOne: async (query) => await ApiHandler.i.auth().get(`/olympiad/find-one?${query.toString()}`),
  getActive: async () => await ApiHandler.i.auth().get('/olympiad/active'),
  getFinalStepRequestAvailable: async () => await ApiHandler.i.auth().get('/olympiad/final-step-request-available'),
  getLocationRegistrationOpened: async () => await ApiHandler.i.auth().get('/olympiad/location-registration-opened'),
  getOne: async (olympiadId) => await ApiHandler.i.auth().get(`/olympiad/${olympiadId}`),
  getByParticipant: async (query) => await ApiHandler.i.auth().get(`/olympiad/by-participant?${query}`),
  getParticipantRegistrationOpened: async () => await ApiHandler.i.auth().get('/olympiad/participant-registration-opened'),
  postOne: async (data, options) => await ApiHandler.i.auth().post('/olympiad', data, options),
  putOne: async (olympiadId, data, options) => await ApiHandler.i.auth().put(`/olympiad/${olympiadId}`, data, options),
};

export default Olympiad;
